<app-dialog
    [visible]="hasPendingRequests()"
    [header]="'COMPLIANCE.HEADER' | translate"
    [modal]="true"
    [closable]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    [style]="{ width: '480px' }"
>
    <div class="flex flex-col gap-5 mb-6">
        <p class="text-body-medium text-secondaryLabel">
            {{ 'COMPLIANCE.DESCRIPTION' | translate }}
        </p>

        <div class="flex flex-col gap-4">
            @for (request of pendingRequests(); track request.type) {
                @if (
                    request.type === ComplianceRequestType.TERMS_AND_CONDITIONS_ACCEPTANCE ||
                    request.type === ComplianceRequestType.ACCEPTABLE_USE_POLICY_ACCEPTANCE ||
                    request.type === ComplianceRequestType.PRIVACY_POLICY_ACCEPTANCE
                ) {
                    <div class="flex items-center">
                        <app-checkbox
                            [inputId]="'complianceRequest_' + request.type"
                            [ngModel]="isAccepted(request.type)"
                            (ngModelChange)="onRequestAcceptedChange(request.type, $event)"
                            [binary]="true"
                        />
                        <label [for]="'complianceRequest_' + request.type" class="text-label-medium-r text-bodyText ml-2 cursor-pointer">
                            {{ 'COMPLIANCE.' + request.type + '.STATEMENT_PREFIX' | translate }}
                            <a
                                [routerLink]="complianceRequestRoutes[request.type]"
                                [queryParams]="{ hideBack: true }"
                                target="_blank"
                                rel="noopener"
                                (click)="$event.stopPropagation()"
                                class="text-primaryText underline cursor-pointer"
                            >
                                {{ 'COMPLIANCE.' + request.type + '.STATEMENT_LINK' | translate }}
                            </a>
                        </label>
                    </div>
                } @else {
                    <app-checkbox
                        [inputId]="'complianceRequest_' + request.type"
                        [ngModel]="isAccepted(request.type)"
                        (ngModelChange)="onRequestAcceptedChange(request.type, $event)"
                        [binary]="true"
                        [label]="'COMPLIANCE.' + request.type + '.STATEMENT' | translate"
                    />
                }
            }
        </div>
    </div>
    <div class="flex gap-3">
        <app-button
            [label]="'COMPLIANCE.CONFIRM' | translate"
            variant="primary"
            [fluid]="true"
            class="basis-1/2"
            [loading]="submitting()"
            [disabled]="!allAccepted()"
            (onClick)="submit()"
        />
        <app-button
            [label]="'COMPLIANCE.LOGOUT' | translate"
            variant="secondary"
            [fluid]="true"
            class="basis-1/2"
            (onClick)="logout()"
        />
    </div>
</app-dialog>
